import { render, staticRenderFns } from "./addzyf.vue?vue&type=template&id=2f9d0a44&scoped=true"
import script from "./addzyf.vue?vue&type=script&lang=js"
export * from "./addzyf.vue?vue&type=script&lang=js"
import style0 from "./addzyf.vue?vue&type=style&index=0&id=2f9d0a44&prod&lang=less&scoped=true"
import style1 from "./addzyf.vue?vue&type=style&index=1&id=2f9d0a44&prod&lang=less"
import style2 from "./addzyf.vue?vue&type=style&index=2&id=2f9d0a44&prod&lang=less"
import style3 from "./addzyf.vue?vue&type=style&index=3&id=2f9d0a44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d0a44",
  null
  
)

export default component.exports